import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardContent, styled } from '@mui/material'
import { createElement, memo } from 'react'
import { Link } from 'react-router-dom'
import { DashBoardCard } from '../../../../types'

export const StyledCard = styled(Card)(({ theme }) => ({
  margin: '23px',
  width: '400px',
  height: '280px',
  float: 'left',
  background: '#fff',
  boxShadow: '0 3px 10px rgba(0, 0, 0, .3)',
  position: 'relative'
}))

interface DashboardCardProps {
  isCorporate: boolean
  customerNumber: string
  card: DashBoardCard
}

const DashboardCard = ({ isCorporate, customerNumber, card }: DashboardCardProps) => {
  const { title, icon, link, content } = card

  const cardLink = isCorporate
    ? `/corp/practice/${customerNumber}${link}`
    : `/practice${link}`

  return (
    <StyledCard>
      <div className="card-header-bg"></div>
      <div className="card-header-info-wrap">
        <div className="card-header-photo-wrapper">
          <Link to={cardLink}>
            {typeof icon === 'string' ? (
              <img
                className={`card-header-photo ${title.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-')}`}
                src={icon}
                alt={title}
              />
            ) : (
              <FontAwesomeIcon
                className="card-header-icon"
                icon={icon}
              />
            )}
          </Link>
        </div>
        <div className="card-header-title">
          <Link to={cardLink}>
            {title}
          </Link>
        </div>
      </div>
      <CardContent style={{ paddingRight: '16px', paddingLeft: '16px' }}>
        { createElement(content, { link: cardLink }) }
      </CardContent>
    </StyledCard>
  )
}

export default memo(DashboardCard)